import { render, staticRenderFns } from "./ToolSourceMenuItem.vue?vue&type=template&id=341a5d24&"
import script from "./ToolSourceMenuItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./ToolSourceMenuItem.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports